module.exports = __webpack_public_path__ + "img/logo-bolle.30c69aa5.svg";